import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46824f3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-items" }
const _hoisted_2 = ["aria-label", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filter.availableOptions, (option) => {
      return (_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["filter-item", { selected: $setup.isSelected(option.key) }]),
        key: option.key,
        "aria-label": option.name,
        onClick: ($event: any) => ($setup.onClickOption($props.filter, option.key))
      }, _toDisplayString(option.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}